module.exports = __webpack_public_path__ + "static/media/Shabnam-Medium.599dec88.eot";